import db from 'database';
import Helpers from 'shared/helpers';
import moment from 'moment';

export default class Queue {
  _id;
  table;
  requestData;

  /**
   *
   * @param {Object} data
   * @param {string} data.table
   * @param {string} [data.url]
   * @param {Number} data.localId
   * @param {String} [data.requestMethod]
   * @param {String} [data.requestBody]
   * @param {String} [data.requestHeaders]
   * @param {String} [data.urlParams]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  save() {
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    return db.queue.put(this);
  }

  static describe = () => '++_id, table, localId';
}
